import { useEffect, useState } from 'react';
import { usePageProps } from '../context/PageContext';
import { checkIsIphone } from '../utils/helpers/getDeviceType';

export const useIsIphone = () => {
  const { device } = usePageProps();
  const [isIphone, setIsIphone] = useState(false);

  useEffect(() => {
    const newState = device?.model
      ? checkIsIphone(device)
      : /iPhone/.test(navigator.userAgent) && !window.MSStream;
    setIsIphone(newState);
  }, []);

  return isIphone;
};
